// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2k2Ew","title":"Images90_title__24Jm6","images":"Images90_images__3gN2t"};